/**
 * @generated SignedSource<<06620ef661eb54ce193151853a640f75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReportUserFileType = "EXPORT" | "INPUT" | "OUTPUT" | "SOURCE" | "%future added value";
export type AddReportUserFileInput = {
  clientMutationId?: string | null;
  reportId: any;
  type: ReportUserFileType;
  userFileId: any;
};
export type useReportAddFileMutation$variables = {
  input: AddReportUserFileInput;
};
export type useReportAddFileMutation$data = {
  readonly addReportUserFile: {
    readonly reportUserFile: {
      readonly type: ReportUserFileType;
      readonly reportId: any;
      readonly userFileId: any;
    } | null;
  } | null;
};
export type useReportAddFileMutation = {
  variables: useReportAddFileMutation$variables;
  response: useReportAddFileMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reportId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userFileId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportAddFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddReportUserFilePayload",
        "kind": "LinkedField",
        "name": "addReportUserFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportUserFile",
            "kind": "LinkedField",
            "name": "reportUserFile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportAddFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddReportUserFilePayload",
        "kind": "LinkedField",
        "name": "addReportUserFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportUserFile",
            "kind": "LinkedField",
            "name": "reportUserFile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc796144274d5f6284336680250fd80d",
    "id": null,
    "metadata": {},
    "name": "useReportAddFileMutation",
    "operationKind": "mutation",
    "text": "mutation useReportAddFileMutation(\n  $input: AddReportUserFileInput!\n) {\n  addReportUserFile(input: $input) {\n    reportUserFile {\n      type\n      reportId\n      userFileId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "21c2ba6ee394efa0f9a10b6308bd3762";

export default node;
